import gql from "graphql-tag";

export default gql`
  fragment PinnableCommentFields on PinnableComment {
    isPinned
    pinnedBy {
      _id
      fullName
    }
  }
`;
